import React, { useEffect, useState } from "react";
import { Outlet, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

export default function Layout() {
  const { lang } = useParams();
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [openCookies, setOpenCookies] = useState(0);

  useEffect(() => {
    const target = lang === "en" ? "en" : "it";
    if (i18n.language !== target) i18n.changeLanguage(target);
    document.documentElement.lang = target;
  }, [lang, i18n]);

  useEffect(() => {
    document.title = t("meta.title");
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [t, location.pathname, i18n.language]);

  // Handle in-page hash anchors (e.g. /it#contact) after route mount
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location.hash, location.pathname]);

  return (
    <div className="ec-app">
      <Header />
      <main className="ec-main">
        <Outlet />
      </main>
      <Footer onOpenCookies={() => setOpenCookies((n) => n + 1)} />
      <CookieBanner forceOpen={openCookies} onClose={() => {}} />
    </div>
  );
}
